import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from '../calvin-emr-shared/guards/login.guard';
import { ForgotPasswordPageComponent } from './forgot-password-page/forgot-password-page.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { PATH_LOGIN, PATH_FORGOT_PASSWORD } from './login.global';
import { PATH_PATIENTS } from 'src/app/patients/patients.global';

const routes: Routes = [
  {
    path: PATH_LOGIN,
    component: LoginPageComponent,
    canActivate: [() => inject(LoginGuard).canActivate(PATH_PATIENTS)],
  },
  { path: PATH_FORGOT_PASSWORD, component: ForgotPasswordPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
